export const INIT_CHAT = 'INIT_CHAT';
export const SET_UNREAD_MESSAGE_COUNT = 'SET_UNREAD_MESSAGE_COUNT';
export const SET_CHAT_ID = 'SET_CHAT_ID';
export const MESSAGES_ERROR = 'MESSAGES_ERROR';
